import { GET_REVIEW_QUERIES_LOGS,} from '../../common/actionTypes.js';

const INITIAL_STATE = {
  reviewQueriesLogs: [], // Initialize reviewQueriesLogs state

};

const HomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_REVIEW_QUERIES_LOGS: { // Handle the review queries logs action
      return { ...state, reviewQueriesLogs: action.payload }; // Update the reviewQueriesLogs in the state
    }
  
    default:
      return state;
  }
};

export default HomeReducer;
